const { buildErrResponse } = require("../_utils/utils");
const { BASE_URL, BASE_URL_DEV } = require("../_constants/urlConstants");
const { default: Axios } = require("axios");

export const AccesoryService = {
  getAccesoryById,
  getAccesoriesByParams,
  getAccesoriesBySitesAndStorePaginated,
  getAccesoriesBySitesAndStoreParamsPaginated,
  getAccesoriesBySitePaginated,
  getAccesoryByBrand,
  getAccesoryAllBrands,
  postAccesory,
  updateAccesory,
  updateBulkAccesory,
  updateAvailableStatus,
  bulkUpdateAccesoryPrices,
};

function getAccesoryById(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/accesory/by-id?id=${id}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccesoriesByParams(body) {
  const { barCode, brand, model, subcategoryTypeId } = body;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/accesory/by-params`, {
      params: {
        barCode,
        brand,
        model,
        subcategoryTypeId,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccesoriesBySitesAndStorePaginated(body) {
  const { page, limit } = body;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/accesory/by-sites-store/pagination`, {
      params: {
        // barCode,
        // brand,
        // model,
        // subcategoryTypeId,
        // siteId,
        page,
        limit,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
function getAccesoriesBySitesAndStoreParamsPaginated(body) {
  const { barCode, brand, model, subcategoryTypeId, siteId, page, limit } =
    body;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/accesory/by-sites-store/by-params/pagination`, {
      params: {
        barCode,
        brand,
        model,
        subcategoryTypeId,
        siteId,
        page,
        limit,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccesoriesBySitePaginated(body) {
  const { siteId, inDistribution, page, limit } = body;
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/accesory/by-site/pagination`, {
      params: {
        inDistribution,
        siteId,
        page,
        limit,
      },
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccesoryByBrand(brand) {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/accesory/brand?brand=${brand}`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function getAccesoryAllBrands() {
  return new Promise((resolve, reject) => {
    Axios.get(`${BASE_URL_DEV}/accesory/all-brands`)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function postAccesory(body) {
  return new Promise((resolve, reject) => {
    Axios.post(`${BASE_URL_DEV}/accesory`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function updateAccesory(id, body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/accesory/id?id=${id}`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

async function updateBulkAccesory(body) {
  return new Promise(async (resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/accesory`, body)
      .then((resp) => resolve(resp))
      .catch((err) => reject(buildErrResponse(err)));
  });
}

function updateAvailableStatus(body) {
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/accesory/available-status`, body)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}

function bulkUpdateAccesoryPrices(accesoryArray, acesoryParams) {
  //const {  price, cost, discount } = params;
  return new Promise((resolve, reject) => {
    Axios.put(`${BASE_URL_DEV}/accesory/prices`, {
      acesoryParams,
      accesoryArray,
    })
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(buildErrResponse(err));
      });
  });
}
